<!-- Modal Overlay -->
<div *ngIf="isOpen" class="modal-overlay" (click)="onClose()">
  <!-- Modal Content -->
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Mobile Header - only on mobile -->
    <div
      class="sm:hidden p-4 border-b border-gray-200"
      style="padding-top: max(env(safe-area-inset-top) + 1rem, 2rem)"
    >
      <div class="flex items-center justify-between mb-3">
        <h2 class="text-lg font-bold">{{ translations.conversationHistory }}</h2>
        <button
          (click)="onClose()"
          class="text-gray-500 hover:text-gray-700 p-2 -m-2"
          style="
            min-width: 44px;
            min-height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 0.5rem;
          "
        >
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
      </div>

      <!-- Search Box -->
      <div class="relative mb-3">
        <input
          type="text"
          [(ngModel)]="searchQuery"
          (input)="onSearchChange()"
          [placeholder]="translations.searchConversations"
          class="w-full pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
      </div>

      <!-- Action Buttons -->
      <div class="flex gap-2">
        <button
          (click)="onDownloadAll()"
          class="flex-1 px-4 py-2 text-sm font-medium text-blue-700 bg-blue-50 border border-blue-300 rounded-lg hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <svg
            class="w-4 h-4 inline-block mr-1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
            ></path>
          </svg>
          {{ translations.allAudioFiles }}
        </button>
        <button
          (click)="onClearAllHistory()"
          class="flex-1 px-4 py-2 text-sm font-medium text-red-700 bg-red-50 border border-red-300 rounded-lg hover:bg-red-100"
        >
          <svg
            class="w-4 h-4 inline-block mr-1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            ></path>
          </svg>
          {{ translations.clearAll }}
        </button>
      </div>
    </div>
    <!-- Search and Controls -->
    <div class="modal-body hidden sm:block">
      <div class="flex items-center justify-between">
        <div>
          <h2 class="modal-title">{{ translations.conversationHistory }}</h2>
          <p class="modal-subtitle">
            {{ getTotalConversations() }} {{ translations.conversations }} •
            {{ getTotalDuration() }} {{ translations.totalDuration }}
          </p>
        </div>
        <button (click)="onClose()" class="close-button">
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
      </div>
      <div class="flex flex-col sm:flex-row gap-2 sm:gap-4 hidden sm:flex">
        <!-- Search Input -->
        <div class="flex-1">
          <div class="relative search-container">
            <input
              type="text"
              [(ngModel)]="searchQuery"
              (input)="onSearchChange()"
              [placeholder]="translations.searchConversations"
              class="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 search-input"
            />
            <div class="search-icon-container">
              <svg
                class="h-5 w-5 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                ></path>
              </svg>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex gap-2">
          <button
            (click)="onDownloadAll()"
            class="flex-1 px-4 py-2 text-sm font-medium text-blue-700 bg-blue-50 border border-blue-300 rounded-lg hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <svg
              class="w-4 h-4 inline-block mr-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              ></path>
            </svg>
            {{ translations.downloadAll }}
          </button>
          <button
            (click)="onClearAllHistory()"
            class="flex-1 px-4 py-2 text-sm font-medium text-red-700 bg-red-50 border border-red-300 rounded-lg hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-500"
          >
            <svg
              class="w-4 h-4 inline-block mr-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              ></path>
            </svg>
            {{ translations.clearAll }}
          </button>
        </div>
      </div>
    </div>

    <!-- Conversations List -->
    <div class="conversation-list">
      <div *ngIf="filteredConversations.length === 0" class="text-center py-12">
        <div class="text-gray-400 text-6xl mb-4">💬</div>
        <h3 class="text-lg font-medium text-gray-900 mb-2">
          {{ searchQuery ? translations.noConversationsFound : translations.noConversationsYet }}
        </h3>
        <p class="text-gray-600">
          {{
            searchQuery
              ? translations.tryAdjustingSearch
              : translations.startConversationToSee
          }}
        </p>
      </div>

      <div *ngIf="filteredConversations.length > 0" class="space-y-4">
        <div
          *ngFor="
            let conversation of filteredConversations;
            trackBy: trackByConversationId
          "
          class="bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition-colors"
        >
          <!-- Conversation Header -->
          <div class="mb-3">
            <div class="flex items-center gap-2 mb-1">
              <span class="text-sm font-medium text-gray-900">
                {{
                  (conversation.userLanguage || "UNKNOWN")
                    .toString()
                    .toUpperCase()
                }}
                →
                {{
                  (conversation.targetLanguage || "UNKNOWN")
                    .toString()
                    .toUpperCase()
                }}
              </span>
              <span class="text-xs text-gray-500">•</span>
              <span class="text-xs text-gray-500">{{
                formatTimestamp(conversation.timestamp || 0)
              }}</span>
              <span *ngIf="conversation.duration" class="text-xs text-gray-500"
                >•</span
              >
              <span *ngIf="conversation.duration" class="text-xs text-gray-500">
                {{ formatDuration(conversation.duration) }}
              </span>
            </div>
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <span class="text-xs text-gray-500">{{ translations.confidence }}:</span>
                <div class="flex items-center gap-1">
                  <div
                    class="w-16 h-2 bg-gray-200 rounded-full overflow-hidden"
                  >
                    <div
                      class="h-full transition-all duration-300"
                      [class]="
                        (conversation.confidence || 0) > 0.8
                          ? 'bg-green-500'
                          : (conversation.confidence || 0) > 0.6
                          ? 'bg-yellow-500'
                          : 'bg-red-500'
                      "
                      [style.width.%]="(conversation.confidence || 0) * 100"
                    ></div>
                  </div>
                  <span class="text-xs text-gray-600"
                    >{{
                      Math.round((conversation.confidence || 0) * 100)
                    }}%</span
                  >
                </div>
              </div>
            </div>
          </div>

          <!-- Conversation Content -->
          <div class="space-y-3">
            <!-- Original Text -->
            <div class="mb-2">
              <div class="text-sm text-gray-600 mb-1">
                <strong
                  >{{
                    conversation.inputType === "text"
                      ? translations.youWrote
                      : conversation.inputType === "speech"
                      ? translations.youSpoke
                      : translations.youSpoke
                  }}
                  {{ getLanguageName(conversation.userLanguage) }}:</strong
                >
              </div>
              <div class="p-2 bg-white rounded border">
                {{ conversation.originalText || translations.noOriginalText }}
              </div>
            </div>

            <!-- Translated Text -->
            <div>
              <div class="text-sm text-gray-600 mb-1">
                <strong
                  >{{
                    conversation.inputType === "text"
                      ? translations.partnerWrote
                      : conversation.inputType === "speech"
                      ? translations.partnerHears
                      : translations.partnerHears
                  }}
                  {{ getLanguageName(conversation.targetLanguage) }}:</strong
                >
              </div>
              <div class="p-2 bg-white rounded border">
                {{ conversation.translatedText || translations.noTranslation }}
              </div>
            </div>
          </div>

          <!-- Audio Players - Positioned below all text content -->
          <div class="space-y-2">
            <!-- Recorded Audio Player - Original recorded speech (only for speech input) -->
            <div
              *ngIf="
                conversation.inputType === 'speech' &&
                hasPartnerAudio(conversation)
              "
              class="mt-2"
            >
              <div
                class="text-xs text-gray-500 mb-1 flex justify-between items-center"
              >
                <span
                  >🎙️ {{ translations.youSpoke }}
                  {{ getLanguageName(conversation.userLanguage) }}:</span
                >
                <button
                  (click)="
                    downloadAudio(
                      getPartnerAudioUrl(conversation),
                      'you-spoke-' +
                        getLanguageName(conversation.userLanguage) +
                        '-' +
                        conversation.id +
                        '.mp3'
                    )
                  "
                  class="text-blue-500 hover:text-blue-700 text-sm px-2 py-1 flex items-center"
                  title="Download"
                >
                  <svg
                    class="w-4 h-4 mr-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                    ></path>
                  </svg>
                  {{ translations.download }}
                </button>
              </div>
              <audio
                [src]="getPartnerAudioUrl(conversation)"
                controls
                class="w-full"
                controlsList="nodownload"
                preload="none"
              ></audio>
            </div>

            <!-- Generate Audio Button for speech input without recorded audio -->
            <div
              *ngIf="
                conversation.inputType === 'speech' &&
                !hasPartnerAudio(conversation) &&
                conversation.originalText
              "
              class="mt-2"
            >
              <button
                (click)="generateOriginalAudioForEntry(conversation)"
                [disabled]="isGeneratingOriginalAudio(conversation.id)"
                class="w-full px-4 py-2 text-sm font-medium rounded-lg transition-colors flex items-center justify-center"
                [class.bg-green-600]="
                  !isGeneratingOriginalAudio(conversation.id)
                "
                [class.hover:bg-green-700]="
                  !isGeneratingOriginalAudio(conversation.id)
                "
                [class.text-white]="!isGeneratingOriginalAudio(conversation.id)"
                [class.bg-gray-400]="isGeneratingOriginalAudio(conversation.id)"
                [class.cursor-not-allowed]="
                  isGeneratingOriginalAudio(conversation.id)
                "
              >
                <span
                  *ngIf="!isGeneratingOriginalAudio(conversation.id)"
                  class="flex items-center"
                >
                  <svg
                    class="w-4 h-4 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"
                    ></path>
                  </svg>
                  {{ translations.generateAudioFor }}
                  {{ getLanguageName(conversation.userLanguage) }}
                </span>
                <span
                  *ngIf="isGeneratingOriginalAudio(conversation.id)"
                  class="flex items-center"
                >
                  <svg
                    class="animate-spin w-4 h-4 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  {{ translations.generating }}
                </span>
              </button>
            </div>

            <!-- Original Audio Player - TTS of original text (for text input only) -->
            <div
              *ngIf="
                hasOriginalAudio(conversation) &&
                conversation.inputType === 'text'
              "
              class="mt-2"
            >
              <div
                class="text-xs text-gray-500 mb-1 flex justify-between items-center"
              >
                <span
                  >🔊 {{ translations.youWrote }}
                  {{ getLanguageName(conversation.userLanguage) }}
                  (audio):</span
                >
                <button
                  (click)="
                    downloadAudio(
                      getOriginalAudioUrl(conversation),
                      'you-wrote-' +
                        getLanguageName(conversation.userLanguage) +
                        '-' +
                        conversation.id +
                        '.mp3'
                    )
                  "
                  class="text-blue-500 hover:text-blue-700 text-sm px-2 py-1 flex items-center"
                  title="Download"
                >
                  <svg
                    class="w-4 h-4 mr-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                    ></path>
                  </svg>
                  {{ translations.download }}
                </button>
              </div>
              <audio
                [src]="getOriginalAudioUrl(conversation)"
                controls
                class="w-full"
                controlsList="nodownload"
                preload="none"
              ></audio>
            </div>

            <!-- Translated Audio Player -->
            <div *ngIf="hasTranslatedAudio(conversation)" class="mt-2">
              <div
                class="text-xs text-gray-500 mb-1 flex justify-between items-center"
              >
                <span
                  >🔊
                  {{
                    conversation.inputType === "text"
                      ? translations.partnerWrote
                      : translations.partnerHears
                  }}
                  {{ getLanguageName(conversation.targetLanguage) }}
                  (audio):</span
                >
                <button
                  (click)="
                    downloadAudio(
                      getTranslatedAudioUrl(conversation),
                      'partner-' +
                        (conversation.inputType === 'text'
                          ? 'wrote'
                          : 'hears') +
                        '-' +
                        getLanguageName(conversation.targetLanguage) +
                        '-' +
                        conversation.id +
                        '.mp3'
                    )
                  "
                  class="text-blue-500 hover:text-blue-700 text-sm px-2 py-1 flex items-center"
                  title="Download"
                >
                  <svg
                    class="w-4 h-4 mr-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                    ></path>
                  </svg>
                  {{ translations.download }}
                </button>
              </div>
              <audio
                [src]="getTranslatedAudioUrl(conversation)"
                controls
                class="w-full"
                controlsList="nodownload"
                preload="none"
              ></audio>
            </div>

            <!-- Generate Audio Button for entries without TTS -->
            <div
              *ngIf="
                !hasTranslatedAudio(conversation) && conversation.translatedText
              "
              class="mt-2"
            >
              <button
                (click)="generateAudioForEntry(conversation)"
                [disabled]="isGeneratingAudio(conversation.id)"
                class="w-full px-4 py-2 text-sm font-medium rounded-lg transition-colors flex items-center justify-center"
                [class.bg-blue-600]="!isGeneratingAudio(conversation.id)"
                [class.hover:bg-blue-700]="!isGeneratingAudio(conversation.id)"
                [class.text-white]="!isGeneratingAudio(conversation.id)"
                [class.bg-gray-400]="isGeneratingAudio(conversation.id)"
                [class.cursor-not-allowed]="isGeneratingAudio(conversation.id)"
              >
                <span
                  *ngIf="!isGeneratingAudio(conversation.id)"
                  class="flex items-center"
                >
                  <svg
                    class="w-4 h-4 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"
                    ></path>
                  </svg>
                  {{ translations.generateAudioFor }}
                  {{ getLanguageName(conversation.targetLanguage) }}
                </span>
                <span
                  *ngIf="isGeneratingAudio(conversation.id)"
                  class="flex items-center"
                >
                  <svg
                    class="animate-spin w-4 h-4 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  {{ translations.generating }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
